// Hooks/index.tsx
import { FC } from 'react'
import { AuthProvider } from './Auth'
import { ToastProvider } from './ToasContext'
import { ForcePasswordReset } from '../Components/ForcePasswordReset/force-password-reset.component'

const HooksProvider: FC<{ children: React.ReactNode }> = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      <ForcePasswordReset />
      {children}
    </ToastProvider>
  </AuthProvider>
)

export { HooksProvider }
